<template>
  <a-modal width="70%" :title="$t('supervise.personalConfig')" v-model="visable" centered @ok="handleOk" destroyOnClose :confirmLoading="okLoading">
    <div class="setting">
      <div class="head">
        <div class="title">{{$t('supervise.groupConfig')}}</div>
        <div class="title"></div>
        <div class="title">{{$t('supervise.personalConfig')}}</div>
      </div>
      <div class="body">
        <div v-if="showGps" class="item">
          <div></div>
          <div></div>
          <div class="personal enable">
            <div class="key" title="当GPS信号可用时，优先采集GPS位置点">{{'优先GPS'}}:</div>
            <div class="value">
              <a-switch size="small" v-model="useGps" @change="changeGps" ></a-switch>
              <span style="padding-left: 10px; color: red" v-show="useGps">{{'注意: 开启此功能会加速腕表的电量消耗'}}</span>
            </div>
          </div>
        </div>
        <div class="item">
          <div :class="has.locateFreq ? 'group disable' : 'group enable'">
            <div class="key">{{ z52 ? $t('supervise.locateFreq') : $t('supervise.locateFreqBase')}}:</div>
            <div class="value">{{groupConfig.locateFreq
              ? (groupConfig.locateFreq < 60
              ? groupConfig.locateFreq + $t('global.second')
              : groupConfig.locateFreq / 60 + $t('global.minute'))
              : $t('global.none')}}</div>
          </div>
          <div class="check">
            <a-checkbox v-model="has.locateFreq"></a-checkbox>
          </div>
          <div v-if="has.locateFreq" class="personal enable">
            <div class="key">{{ z52 ? $t('supervise.locateFreq') : $t('supervise.locateFreqBase')}}:</div>
            <div class="value">
              <a-select size="small" :defaultValue="locateFreq"
                style="width: 125px" v-model="locateFreq">
                <template v-for="(item, index) in locateFreqChoose">
                  <a-select-option :key="index" :value="item.key">{{item.label}}</a-select-option>
                </template>
              </a-select>
            </div>
          </div>
        </div>

        <div class="item" v-if="!z52">
          <div :class="has.locateFreqBle ? 'group disable' : 'group enable'">
            <div class="key">{{$t('supervise.locateFreqBle')}}:</div>
            <div class="value">{{groupConfig.locateFreqBle
              ? (groupConfig.locateFreqBle < 60
                  ? groupConfig.locateFreqBle + $t('global.second')
                  : groupConfig.locateFreqBle / 60 + $t('global.minute'))
              : $t('global.none')}}</div>
          </div>
          <div class="check">
            <a-checkbox v-model="has.locateFreqBle"></a-checkbox>
          </div>
          <div v-if="has.locateFreqBle" class="personal enable">
            <div class="key">{{$t('supervise.locateFreqBle')}}:</div>
            <div class="value">
              <a-select size="small" :defaultValue="locateFreqBle"
                        style="width: 125px" v-model="locateFreqBle">
                <template v-for="(item, index) in freqOptionsBle">
                  <a-select-option :key="index" :value="item.key">{{item.label}}</a-select-option>
                </template>
              </a-select>
            </div>
          </div>
        </div>

        <div class="item" v-if="!z52">
          <div :class="has.locateFreqGps ? 'group disable' : 'group enable'">
            <div class="key">{{$t('supervise.locateFreqGps')}}:</div>
            <div class="value">{{groupConfig.locateFreqGps
              ? (groupConfig.locateFreqGps < 60
              ? groupConfig.locateFreqGps + $t('global.second')
              : groupConfig.locateFreqGps / 60 + $t('global.minute'))
              : $t('global.none')}}</div>
          </div>
          <div class="check">
            <a-checkbox v-model="has.locateFreqGps"></a-checkbox>
          </div>
          <div v-if="has.locateFreqGps " class="personal enable">
            <div class="key">{{$t('supervise.locateFreqGps')}}:</div>
            <div class="value">
              <a-select size="small" :defaultValue="locateFreqGps"
                        style="width: 125px" v-model="locateFreqGps">
                <template v-for="(item, index) in freqOptionsGps">
                  <a-select-option :key="index" :value="item.key">{{item.label}}</a-select-option>
                </template>
              </a-select>
            </div>
          </div>
        </div>

         <div class="item" v-if="z62">
          <div :class="has.heartbeatFreq ? 'group disable' : 'group enable'">
            <div class="key">{{ $t('supervise.heartbeatFreq')}}:</div>
            <div class="value">{{groupConfig.heartbeatFreq
              ? (groupConfig.heartbeatFreq < 60
              ? groupConfig.heartbeatFreq + $t('global.second')
              : groupConfig.heartbeatFreq / 60 + $t('global.minute'))
              : $t('global.none')}}</div>
          </div>
          <div class="check">
            <a-checkbox v-model="has.heartbeatFreq"></a-checkbox>
          </div>
          <div v-if="has.heartbeatFreq" class="personal enable">
            <div class="key">{{ $t('supervise.heartbeatFreq')}}:</div>
            <div class="value">
              <a-select size="small" :defaultValue="heartbeatFreq"
                style="width: 125px" v-model="heartbeatFreq">
                <template v-for="(item, index) in heartbeatFreqChoose">
                  <a-select-option :key="index" :value="item.key">{{item.label}}</a-select-option>
                </template>
              </a-select>
            </div>
          </div>
        </div>
        
         <div class="item" v-if="z62">
          <div :class="has.oxygenFreq ? 'group disable' : 'group enable'">
            <div class="key">{{ $t('supervise.oxygenFreq')}}:</div>
            <div class="value">{{groupConfig.oxygenFreq
              ? (groupConfig.oxygenFreq < 60
              ? groupConfig.oxygenFreq + $t('global.second')
              : groupConfig.oxygenFreq / 60 + $t('global.minute'))
              : $t('global.none')}}</div>
          </div>
          <div class="check">
            <a-checkbox v-model="has.oxygenFreq"></a-checkbox>
          </div>
          <div v-if="has.oxygenFreq" class="personal enable">
            <div class="key">{{ $t('supervise.oxygenFreq')}}:</div>
            <div class="value">
              <a-select size="small" :defaultValue="oxygenFreq"
                style="width: 125px" v-model="oxygenFreq">
                <template v-for="(item, index) in oxygenFreqChoose">
                  <a-select-option :key="index" :value="item.key">{{item.label}}</a-select-option>
                </template>
              </a-select>
            </div>
          </div>
        </div>
        
        <div class="item" v-if="!z52">
          <div :class="has.autoAdjust ? 'group disable' : 'group enable'">
            <div class="key">{{$t('supervise.autoAdjust')}}:</div>
            <div class="value">{{groupConfig.autoAdjust ? $t('global.enable') : $t('global.disable')}}</div>
          </div>
          <div class="check">
            <a-checkbox v-model="has.autoAdjust"></a-checkbox>
          </div>
          <div v-if="has.autoAdjust" class="personal enable">
            <div class="key">{{$t('supervise.autoAdjust')}}:</div>
            <div class="value">
              <a-switch size="small" :defaultValue="autoAdjust" v-model="autoAdjust"></a-switch>
            </div>
          </div>
        </div>

        <div class="item" v-if="!z52">
          <div :class="has.autoPowerUp ? 'group disable' : 'group enable'">
            <div class="key">{{$t('supervise.autoPowerUp')}}:</div>
            <div class="value">{{groupConfig.autoPowerUp ? $moment(groupConfig.autoPowerUp * 1000 + $moment().startOf('day')).format('HH:mm') : $t('global.none')}}</div>
          </div>
          <div class="check">
            <a-checkbox @change="autoPowerChanged"  v-model="has.autoPowerUp"></a-checkbox>
          </div>
          <div v-if="has.autoPowerUp" class="personal enable">
            <div class="key">{{$t('supervise.autoPowerUp')}}:</div>
            <div class="value">
              <a-time-picker size="small" :allowClear="true" :defaultValue="$moment(autoPowerUp * 1000 + $moment().startOf('day'))"
                @change="powerUpTimeChange"
                :disabled="has.enablePersonalPowerUpAndDown"
                :value="$moment(autoPowerUp * 1000 + $moment().startOf('day'))" :placeholder="$t('supervise.selecteTimeTip')"
                format="HH:mm" />
              <a-checkbox v-model="has.enablePersonalPowerUpAndDown" style="margin-left: 10px">{{$t('supervise.yzkj')}}</a-checkbox>
            </div>
          </div>
        </div>

        <div class="item" v-if="!z52">
          <div :class="has.autoPowerDown ? 'group disable' : 'group enable'">
            <div class="key">{{$t('supervise.autoPowerDown')}}:</div>
            <div class="value">{{groupConfig.autoPowerDown ? $moment(groupConfig.autoPowerDown * 1000 + $moment().startOf('day')).format('HH:mm') : $t('global.none')}}</div>
          </div>
          <div class="check">
            <a-checkbox @change="autoPowerChanged"  v-model="has.autoPowerDown"></a-checkbox>
          </div>
          <div v-if="has.autoPowerDown" class="personal enable">
            <div class="key">{{$t('supervise.autoPowerDown')}}:</div>
            <div class="value">
              <a-time-picker size="small" :defaultValue="$moment(autoPowerDown * 1000 + $moment().startOf('day'))"
                @change="powerDownTimeChange"
                :disabled="has.enablePersonalPowerUpAndDown"
                :value="$moment(autoPowerDown * 1000 + $moment().startOf('day'))" :placeholder="$t('supervise.selecteTimeTip')"
                format="HH:mm" />
            </div>
          </div>
        </div>

        <div class="item" v-if="!z52">
          <div :class="has.customLocate ? 'group disable' : 'group enable'">
            <div class="key">{{$t('supervise.timeOption')}}:</div>
            <div class="value">
              <template v-for="(item, index) in groupConfig.customLocate">
                <div :key="index">
                  {{$moment(item.startTime * 1000 + $moment().startOf('day')).format('HH:mm') + '~' + $moment(item.endTime * 1000 + $moment().startOf('day')).format('HH:mm') + ' / ' + $moment.duration({seconds: item.intervalTime}).humanize()}}
                </div>
              </template>
            </div>
          </div>
          <div class="check">
            <a-checkbox v-model="has.customLocate"></a-checkbox>
          </div>
          <div v-if="has.customLocate" class="personal enable">
            <div class="key">{{$t('supervise.timeOption')}}:</div>
            <div class="value">
              <div class="lists">
                <template v-for="(item, index) in customLocate">
                  <div :key="index" class="list">
                    <a-time-picker size="small"
                    v-model="item.startTime" :placeholder="$t('supervise.selecteTimeTip')"
                    format="HH:mm" />
                    <span class="span">~</span>
                    <a-time-picker size="small"
                    v-model="item.endTime" :placeholder="$t('supervise.selecteTimeTip')"
                    format="HH:mm" />
                    <span class="span">/</span>
                    <a-select size="small" :defaultValue="item.intervalTime" v-model="item.intervalTime">
                      <template v-for="(item, index) in freqOptions">
                        <a-select-option :key="index" :value="item.key">{{item.label}}</a-select-option>
                      </template>
                    </a-select>
                    <a-button class="deleteBtn" @click="deleteTime(index)" size="small">
                      <zx-icon type="icon-shanchu1"></zx-icon>
                      {{$t('global.delete')}}
                    </a-button>
                  </div>
                </template>
                <div v-if="customLocate.length < 3" class="add">
                  <a-button @click="addTime" size="small" type="primary">
                    <zx-icon type="icon-jia1"></zx-icon>
                    {{$t('supervise.addTimeOption')}}
                  </a-button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div>
      <a-alert class="tip"  :message="$t('global.tips') + ':'" type="info" showIcon>
        <p slot="description">
          {{ $t('global.personalConfigTip') }}
        </p>
      </a-alert>
    </div>
  </a-modal>
</template>
<script>
  import config from '../../config/'
  export default {
    data() {
      return {
        // 确定按钮加载状态
        okLoading: false,
        // 用户配置属性
        locateFreq: 1800,
        locateFreqBle: 1800,
        locateFreqGps: 1800,
        oxygenFreq: 300,
        heartbeatFreq: 300,
        autoAdjust: false,
        autoPowerUp: 0,
        autoPowerDown: 0,
        enablePersonalPowerUpAndDown: false,
        customLocate: [],
        // 个人配置是否有初始属性或用户自己配置
        has: {
          locateFreq: false,
          locateFreqBle: false,
          locateFreqGps: false,
          oxygenFreq: false,
          heartbeatFreq: false,
          autoAdjust: false,
          autoPowerUp: false,
          autoPowerDown: false,
          customLocate: false,
          enablePersonalPowerUpAndDown: false,
        },
        // hasPersonalLocalFreq: false,
        // hasPersonalAutoAdjust: false,
        // hasPersonalPower: false,
        // hasPersonalLocate: false,
        // .
        personId: '',
        visable: false,
        initData: '',
        z52: true,
        z62: true,
        groupConfig: '',
        personalConfig: '',
        showGps: false,
        useGps: false,
        specialModelFreqSetting:false, 
      }
    },
    computed: {
       oxygenFreqChoose () {
        return this.z62FreqOptions
      },
      heartbeatFreqChoose () {
        return this.z62FreqOptions
      },
      locateFreqChoose () {
        return this.z52 ? this.z52FreqOptions : this.freqOptions
      },
       z52FreqOptions () {
        let freq = []
         for(let i=1;i<60;i++){
          freq.push({"key":i,"label":i + this.$t('global.second')},)
        }
        for(let i=1;i<60;i++){
          freq.push({"key":i*60,"label":i + this.$t('global.minute')},)
        }
        for(let i=1;i<=24;i++){
          freq.push({"key":i*60*60,"label":i + this.$t('global.hour')},)
        }
        return freq
      },
      z62FreqOptions () {
        let freq = []
        for(let i=0;i<60;i++){
          freq.push({"key":i*60,"label":i + this.$t('global.minute')},)
        }
        for(let i=1;i<=12;i++){
          freq.push({"key":i*60*60,"label":i + this.$t('global.hour')},)
        }
        return freq
      },
      freqOptions () {
        return [
          {"key":1,"label":"1" + this.$t('global.second')},
          {"key":5,"label":"5" + this.$t('global.second')},
          {"key":10,"label":"10" + this.$t('global.second')},
          {"key":20,"label":"20" + this.$t('global.second')},
          {"key":30,"label":"30" + this.$t('global.second')},
          {"key":300,"label":"5" + this.$t('global.minute')},
          {"key":600,"label":"10" + this.$t('global.minute')},
          {"key":900,"label":"15" + this.$t('global.minute')},
          {"key":1200,"label":"20" + this.$t('global.minute')},
          {"key":1800,"label":"30" + this.$t('global.minute')},
          {"key":2400,"label":"40" + this.$t('global.minute')},
          {"key":3600,"label":"60" + this.$t('global.minute')}
        ]
      },
      freqOptionsBle () {
        return [
          {"key":5,"label":"5" + this.$t('global.second')},
          {"key":10,"label":"10" + this.$t('global.second')},
          {"key":15,"label":"15" + this.$t('global.second')},
          {"key":30,"label":"30" + this.$t('global.second')},
          {"key":60,"label":"1" + this.$t('global.minute')},
          {"key":300,"label":"5" + this.$t('global.minute')},
          {"key":600,"label":"10" + this.$t('global.minute')},
          {"key":1800,"label":"30" + this.$t('global.minute')}
        ]
      },
      freqOptionsGps () {
        return [
          {"key":5,"label":"5" + this.$t('global.second')},
          {"key":10,"label":"10" + this.$t('global.second')},
          {"key":20,"label":"20" + this.$t('global.second')},
          {"key":30,"label":"30" + this.$t('global.second')},
          {"key":60,"label":"1" + this.$t('global.minute')},
          {"key":300,"label":"5" + this.$t('global.minute')},
          {"key":600,"label":"10" + this.$t('global.minute')},
          {"key":1800,"label":"30" + this.$t('global.minute')},
          {"key":2400,"label":"40" + this.$t('global.minute')},
          {"key":3600,"label":"60" + this.$t('global.minute')}
        ]
      }
    },
    methods: {
      handleCljChange(e){
        console.log(e);
        this.locateFreq = null
      },
      init() {
        this.getPersonalConfig(this.personId)
      },
      changeGps (ev) {
        console.log('change ' + ev)
        let param = {
          entityId: this.personId,
          gpsForce: this.useGps
        }
        this.$http.post('/api/entity/v1.0/gpsForce', param).then((res) => {
          let { code} = res
          if (code === 0) {
            this.$notification.success({
              message: '修改成功！'
            })
          } else {
            this.$notification.error({
              message: '失败！'
            })
          }
        })
      },
      // 修改个人配置参数
      modifiedPersonalConfig() {
        this.okLoading = true
        let newConfig = {}
        // console.log(this.has)
        Object.keys(this.has).forEach((key) => {
          if (this.has[key]) {
            if (key === 'customLocate') {
              newConfig[key] = this[key].map((item) => {
                return {
                  startTime: item.startTime.unix() - this.$moment().startOf('day').unix(),
                  endTime: item.endTime.unix() - this.$moment().startOf('day').unix(),
                  intervalTime: item.intervalTime
                }
              })
            } else if (key === 'enablePersonalPowerUpAndDown') {
              newConfig[key] = this.has[key]
            } else {
              newConfig[key] = this[key]
            }
          } else if (key === 'enablePersonalPowerUpAndDown' && this.has[key] == false) {
            newConfig[key] = this.has[key]
          }
        })

        if(newConfig.locateFreq && this.specialModelFreqSetting){
          newConfig.locateFreqBle = this.locateFreqBle
          newConfig.locateFreqGps = this.locateFreqGps
        } 
        let param = Object.assign({}, {
          id: this.personId
        }, newConfig)
        // console.log(param)
        this.$http.put(config.api.put_personnal_config, param).then((res) => {
          // console.log(res)
          // todo
          this.okLoading = false
          if (res.code === 0) {
            this.$notification.success({
              message: this.$t('global.commitSuccess')
            })
            this.visable = false
          } else {
            this.$notification.error({
              message: `${res.desc}`
            })
          }
        })
      },
      // 还原个人配置参数
      recoverPersonalConfig() {
        this.init()
      },
      // 个人时间策略的开始时间
      startTimeChange(time) {
        // console.log(time)
        // console.log(this.customLocate)
        // let startTime = timeToSeconds(val2)
        // this.mergedConfig.customLocate[0].startTime = startTime
      },
      // 个人时间策略的结束时间
      endTimeChange(val, val2) {
        // console.log(val)
        // console.log(this.mergedConfig)
      },
      // 设置自动开关机是否生效
      autoPowerChanged (ev) {
        // console.log(ev)
        if (ev.target.checked) {
          this.has.autoPowerUp = true
          this.has.autoPowerDown = true
        } else {
          this.has.autoPowerUp = false
          this.has.autoPowerDown = false
          this.has.enablePersonalPowerUpAndDown = false
        }
      },
      // 个人设置的自动开机时间
      powerUpTimeChange(value, time) {
        // console.log(value.unix() - this.$moment().startOf('day').unix())
        // console.log(value)
        if (value) {
          this.autoPowerUp = value.unix() - this.$moment().startOf('day').unix()
        } else {
          this.autoPowerUp = null
        }
      },
      // 个人设置的自动关机时间
      powerDownTimeChange(value, time) {
        // console.log(time)
        // this.autoPowerDown = value.unix() - this.$moment().startOf('day').unix()
        if (value) {
          this.autoPowerDown = value.unix() - this.$moment().startOf('day').unix()
        } else {
          this.autoPowerDown = null
        }
      },
      // 添加个人设置时间策略
      addTime() {
        this.customLocate.push({
          startTime: this.$moment().startOf('day'),
          endTime: this.$moment(),
          intervalTime: 1800
        })
      },
      deleteTime(index) {
        this.customLocate.splice(index, 1)
      },
      handleOk() {
        // console.log('ok')
        this.modifiedPersonalConfig()
      },
      showModal(options) {
        // console.log(options)
        this.initData = options
        this.z52 = options.deviceType ? options.deviceType.includes('Z52') : false
        this.z62 = options.deviceType ? options.deviceType.includes('Z62') : false
        this.personId = options.id
        this.getPersonalConfig(this.personId).then(() => {
          console.log(this.personalConfig)
          this.visable = true
        })
      },
      // 获取个人监管配置
      getPersonalConfig(personId) {
        return new Promise((resolve) => {
          this.$http.get(config.api.get_personnal_config + personId).then((res) => {
            // console.log(res)
            let {
              code,
              desc,
              result
            } = res
            if (code === 0 && desc === 'success' && result) {
              // console.log(result)
              // 这里获取到的是所有分组的规则数据
              this.personalConfig = result.personalConfigModel 
              this.setInitPersonalData()
              this.groupConfig = result.groupConfigModel
              this.personalCustomLocate = this.personalConfig.customLocate || []
              // 如果一直开机为true,则设置自动开关机为个人生效
              if (this.has.enablePersonalPowerUpAndDown) {
                this.has.autoPowerUp = true
                this.has.autoPowerDown = true
              }
              // 是否显示GPS
              if (result.deviceFlags && result.deviceFlags % 2 === 1) {
                this.showGps = true
                this.useGps = result.entityFlags && result.entityFlags % 2 === 1 ? true : false
              } else {
                this.showGps = false
              }
              resolve('done')
            }
          })
        })
      },
      setInitPersonalData () {
        Object.keys(this.has).forEach((key) => {
          if (this.personalConfig[key]) {
            if (key === 'customLocate') {
              this[key] = this.personalConfig[key].map((item) => {
                return {
                  startTime: this.$moment(item.startTime * 1000 + this.$moment().startOf('day')),
                  endTime: this.$moment(item.endTime * 1000 + this.$moment().startOf('day')),
                  intervalTime: item.intervalTime
                }
              })
              this.has[key] = true
            } else if (key === 'enablePersonalPowerUpAndDown') {
              if (this.personalConfig[key]) {
                this.has[key] = true
              }
            } else {
              this[key] = this.personalConfig[key]
              this.has[key] = true
            }
          } else {
            this.has[key] = false
          }
        })

        this.specialModelFreqSetting = this.personalConfig.locateFreqBle && this.personalConfig.locateFreqGps
        if(this.specialModelFreqSetting){
          this.locateFreqBle = this.personalConfig.locateFreqBle
          this.locateFreqGps = this.personalConfig.locateFreqGps
        }
      },
      // 删除某一项个人时间策略配置
      deleteCustomLocateItem(index) {
        this.mergedConfig.customLocate.splice(index, 1)
      },
      handleFreqChange(e){
        console.log(e);
        
      }
    }
  }
</script>
<style lang="less" scoped>
@import '../../theme/color.less';
  .setting {
    width: 100%;
    margin-bottom: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .head {
      display: grid;
      grid-template-columns: 360px 30px 500px;
      grid-column-gap: 10px;
      .title {
        margin-left: 20px;
      }
    }
    .body {
      .disable {
        color: @disabled-color;
      }
      .enable {
        color: @primary-color;
      }
      .item {
        height: 50px;
        display: grid;
        grid-template-columns: 360px 30px 610px;
        grid-column-gap: 10px;
        margin-top: 15px;
        .group {
          display: grid;
          grid-template-columns: 200px 170px;
        }
        .personal {
          display: grid;
          grid-template-columns: 200px 400px;
          .value {
            .lists {
              .list {
                margin: 0 0 10px 0;
                display: flex;
                .span {
                  margin: 0 10px;
                }
                .deleteBtn {
                  margin: 0 10px;
                }
              }
            }
          }
        }
      }
    }
  }
  .tip {
    margin: 0 50px;
    color: @link-color;
    font-size: .9rem;
  }
</style>
